/**
 * Gracias QR - Post-Purchase Thank You Page JavaScript
 * Savia PR - Sales Psychology Optimized
 */

(function() {
  'use strict';

  // ===== Configuration =====
  const CONFIG = {
    countdownHours: 48,
    storageKey: 'gracias_discount_expiry',
    confettiDuration: 4000,
    confettiParticles: 150
  };

  // ===== Initialize on DOM Ready =====
  document.addEventListener('DOMContentLoaded', initGraciasPage);

  function initGraciasPage() {
    parseUrlParameters();
    initCountdownTimer();
    initCopyButton();
    initConfetti();
    initReviewStars();
    initSocialSharing();
  }

  // ===== URL Parameter Parsing =====
  function parseUrlParameters() {
    const params = new URLSearchParams(window.location.search);
    
    // Customer Name
    const name = params.get('name') || params.get('nombre');
    if (name) {
      const nameElements = document.querySelectorAll('.customer-name');
      nameElements.forEach(el => {
        el.textContent = decodeURIComponent(name);
      });
    }
    
    // Order Number
    const orderId = params.get('order') || params.get('order_id') || params.get('pedido');
    if (orderId) {
      const orderElements = document.querySelectorAll('.order-id');
      orderElements.forEach(el => {
        el.textContent = decodeURIComponent(orderId);
      });
      
      // Show order section if hidden
      const orderSection = document.querySelector('.gracias-order');
      if (orderSection) {
        orderSection.style.display = 'block';
      }
    }
    
    // Order Total
    const total = params.get('total');
    if (total) {
      const totalElements = document.querySelectorAll('.order-total');
      totalElements.forEach(el => {
        el.textContent = '$' + decodeURIComponent(total);
      });
    }
    
    // Items count
    const items = params.get('items');
    if (items) {
      const itemsElements = document.querySelectorAll('.order-items');
      itemsElements.forEach(el => {
        el.textContent = decodeURIComponent(items);
      });
    }
  }

  // ===== Countdown Timer =====
  function initCountdownTimer() {
    const timerElement = document.querySelector('.gracias-countdown__timer');
    if (!timerElement) return;

    // Get or set expiry time
    let expiryTime = localStorage.getItem(CONFIG.storageKey);
    
    if (!expiryTime) {
      // First visit - set expiry time
      const customHours = timerElement.dataset.hours;
      const hours = customHours ? parseInt(customHours) : CONFIG.countdownHours;
      expiryTime = Date.now() + (hours * 60 * 60 * 1000);
      localStorage.setItem(CONFIG.storageKey, expiryTime);
    } else {
      expiryTime = parseInt(expiryTime);
    }

    function updateTimer() {
      const now = Date.now();
      const remaining = expiryTime - now;

      if (remaining <= 0) {
        timerElement.innerHTML = '<span class="gracias-countdown__expired">¡Oferta expirada!</span>';
        return;
      }

      const hours = Math.floor(remaining / (1000 * 60 * 60));
      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

      timerElement.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    }

    function pad(num) {
      return num.toString().padStart(2, '0');
    }

    // Update every second
    updateTimer();
    setInterval(updateTimer, 1000);
  }

  // ===== Copy Discount Code =====
  function initCopyButton() {
    const copyBtn = document.querySelector('.gracias-discount__copy-btn');
    const codeEl = document.querySelector('.gracias-discount__code');
    
    if (!copyBtn || !codeEl) return;

    copyBtn.addEventListener('click', async function(e) {
      e.preventDefault();
      
      const code = codeEl.textContent.trim();
      
      try {
        await navigator.clipboard.writeText(code);
        showCopySuccess(copyBtn);
      } catch (err) {
        // Fallback for older browsers
        fallbackCopy(code);
        showCopySuccess(copyBtn);
      }
    });

    // Also allow clicking the code itself
    const codeWrapper = document.querySelector('.gracias-discount__code-wrapper');
    if (codeWrapper) {
      codeWrapper.addEventListener('click', function() {
        copyBtn.click();
      });
    }
  }

  function showCopySuccess(btn) {
    const originalHTML = btn.innerHTML;
    btn.classList.add('copied');
    btn.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
      ¡Copiado!
    `;
    
    setTimeout(() => {
      btn.classList.remove('copied');
      btn.innerHTML = originalHTML;
    }, 2000);
  }

  function fallbackCopy(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }

  // ===== Confetti Animation =====
  function initConfetti() {
    const canvas = document.querySelector('.gracias-confetti-canvas');
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    let particles = [];
    let animationId;

    // Set canvas size
    function resizeCanvas() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // Confetti colors
    const colors = ['#d4af37', '#11522f', '#f5e6b3', '#ffffff', '#e8b4b8'];

    // Create particles
    function createParticle() {
      return {
        x: Math.random() * canvas.width,
        y: -20,
        size: Math.random() * 10 + 5,
        speedY: Math.random() * 3 + 2,
        speedX: Math.random() * 4 - 2,
        rotation: Math.random() * 360,
        rotationSpeed: Math.random() * 10 - 5,
        color: colors[Math.floor(Math.random() * colors.length)],
        shape: Math.random() > 0.5 ? 'rect' : 'circle'
      };
    }

    // Initialize particles
    for (let i = 0; i < CONFIG.confettiParticles; i++) {
      const p = createParticle();
      p.y = Math.random() * canvas.height;
      particles.push(p);
    }

    // Animation loop
    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach((p, index) => {
        p.y += p.speedY;
        p.x += p.speedX;
        p.rotation += p.rotationSpeed;

        // Reset particle if off screen
        if (p.y > canvas.height + 20) {
          particles[index] = createParticle();
        }

        // Draw particle
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation * Math.PI / 180);
        ctx.fillStyle = p.color;

        if (p.shape === 'rect') {
          ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
        } else {
          ctx.beginPath();
          ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
          ctx.fill();
        }

        ctx.restore();
      });

      animationId = requestAnimationFrame(animate);
    }

    animate();

    // Stop confetti after duration
    setTimeout(() => {
      cancelAnimationFrame(animationId);
      canvas.style.opacity = '0';
      setTimeout(() => {
        canvas.style.display = 'none';
      }, 500);
    }, CONFIG.confettiDuration);
  }

  // ===== Review Stars & Klaviyo Integration =====
  function initReviewStars() {
    const stars = document.querySelectorAll('.gracias-review__star');
    const form = document.querySelector('.gracias-review__form');
    const successMsg = document.querySelector('.gracias-review__success');
    const submitBtn = document.querySelector('.gracias-review__submit');
    
    if (!stars.length) return;

    // Check for email in URL params to pre-fill
    const params = new URLSearchParams(window.location.search);
    const emailParam = params.get('email');
    if (emailParam) {
      const emailInput = document.getElementById('review-email');
      if (emailInput) emailInput.value = decodeURIComponent(emailParam);
    }

    stars.forEach((star, index) => {
      star.addEventListener('click', function() {
        // Highlight stars
        stars.forEach((s, i) => {
          s.classList.toggle('active', i <= index);
        });
        
        // Show form
        if (form) {
            form.style.display = 'block';
            document.getElementById('review-rating').value = index + 1;
            
            // Focus on email if empty, otherwise body
            const emailInput = document.getElementById('review-email');
            if (emailInput && !emailInput.value) {
                emailInput.focus();
            } else {
                document.getElementById('review-body').focus();
            }
        }
      });

      // Hover effect
      star.addEventListener('mouseenter', function() {
        stars.forEach((s, i) => {
          s.style.color = i <= index ? '#d4af37' : '#e0e0e0';
        });
      });
    });

    // Reset on mouse leave
    const container = document.querySelector('.gracias-review__stars');
    if (container) {
      container.addEventListener('mouseleave', function() {
        const ratingInput = document.getElementById('review-rating');
        const currentRating = ratingInput ? parseInt(ratingInput.value) : 0;
        
        stars.forEach((s, i) => {
          if (currentRating > 0) {
             s.classList.toggle('active', i < currentRating);
             s.style.color = i < currentRating ? '#d4af37' : '#e0e0e0';
          } else {
             s.classList.remove('active');
             s.style.color = '#e0e0e0';
          }
        });
      });
    }

    // Submit Handler
    if (submitBtn) {
        submitBtn.addEventListener('click', function() {
            const email = document.getElementById('review-email').value;
            const body = document.getElementById('review-body').value;
            const rating = document.getElementById('review-rating').value;
            const orderId = document.querySelector('.order-id') ? document.querySelector('.order-id').innerText : 'N/A';

            if (!email || !email.includes('@')) {
                alert('Por favor ingresa un correo electrónico válido.');
                return;
            }

            // Push to Klaviyo
            const _learnq = window._learnq || [];
            
            // 1. Identify User
            _learnq.push(['identify', {
                '$email': email,
                '$first_name': params.get('name') || ''
            }]);

            // 2. Track Event
            _learnq.push(['track', 'Submitted Review', {
                'Rating': parseInt(rating),
                'ReviewBody': body,
                'OrderID': orderId,
                'Source': 'Gracias QR Page'
            }]);

            // Show success
            form.style.display = 'none';
            if (successMsg) successMsg.style.display = 'block';
        });
    }
  }

  // ===== Social Sharing =====
  function initSocialSharing() {
    const shareButtons = document.querySelectorAll('.gracias-social__btn');
    
    shareButtons.forEach(btn => {
      btn.addEventListener('click', function(e) {
        const platform = btn.dataset.platform;
        const shareUrl = encodeURIComponent(window.location.origin);
        const shareText = encodeURIComponent(btn.dataset.text || '¡Acabo de recibir mi pedido de Savia PR! 🎉💚');
        
        let url;
        switch(platform) {
          case 'whatsapp':
            url = `https://wa.me/?text=${shareText}%20${shareUrl}`;
            break;
          case 'facebook':
            url = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
            break;
          case 'instagram':
            // Instagram doesn't have direct share URL, open profile
            url = btn.dataset.url || 'https://instagram.com/saviapr';
            break;
          default:
            return;
        }
        
        if (url) {
          e.preventDefault();
          window.open(url, '_blank', 'width=600,height=400');
        }
      });
    });
  }

  // ===== Track Events (Optional Analytics) =====
  function trackEvent(eventName, data = {}) {
    // Shopify Analytics
    if (window.ShopifyAnalytics) {
      window.ShopifyAnalytics.lib.track(eventName, data);
    }
    
    // Google Analytics 4
    if (window.gtag) {
      window.gtag('event', eventName, data);
    }
    
    // Custom tracking
    console.log('[Gracias QR]', eventName, data);
  }

  // Track page view
  trackEvent('gracias_page_view', {
    source: 'qr_code',
    has_order_id: !!new URLSearchParams(window.location.search).get('order')
  });

})();
